/**
 * Avisos que se quedan en la página. El toast sigue, pero desaparece solo.
 */

export interface PageNotice {
    id: number;
    type: 'ok' | 'err';
    text: string;
}

export function rememberNotice(
    prev: readonly PageNotice[],
    notice: Omit<PageNotice, 'id'>,
    now = Date.now(),
): PageNotice[] {
    const id = prev.some((row) => row.id === now) ? now + prev.length + 1 : now;
    return [{ id, type: notice.type, text: notice.text }, ...prev].slice(0, 12);
}
